module.exports = __webpack_public_path__ + "media/images/illustration-7447397aba82ffbe691586520b190d6d.svg";